import { Vote } from '@/app/types/proposals';
import { formatVotes } from '../helpers/formatVotes';
import { Address } from 'viem';

const fetchFromApi = async (url: string): Promise<any> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch data from ${url}`);
  }
  return response.json();
};

export const fetchUserVotes = async (
  voterId: Address,
): Promise<{
  votes: Vote[];
  totalVotes: number;
}> => {
  try {
    const data = await fetchFromApi(
      `${process.env.NEXT_PUBLIC_VOTES_BY_PROPOSAL}?voter=${voterId}`,
    );

    const votes = formatVotes(data);

    return {
      votes,
      totalVotes: votes.length,
    };
  } catch (error) {
    console.error('Error fetching voter votes:', error);
    throw error;
  }
};
